export default "/assets/images/critter-cuddler-hero.19edf8981e62ca07.png";